"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyInternal = exports.BaseCurrency = void 0;
var __1 = require("..");
var BaseCurrency = /** @class */ (function () {
    function BaseCurrency() {
    }
    Object.defineProperty(BaseCurrency.prototype, "moneyFormat", {
        get: function () {
            // eslint-disable-next-line no-template-curly-in-string
            return __1.bindings.currency.moneyFormat || '${{amount}}';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCurrency.prototype, "currency", {
        get: function () {
            return __1.bindings.currency.activeCurrency || 'USD';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCurrency.prototype, "availableCurrencies", {
        get: function () {
            return __1.bindings.currency.availableCurrencies || [];
        },
        enumerable: false,
        configurable: true
    });
    return BaseCurrency;
}());
exports.BaseCurrency = BaseCurrency;
var CurrencyInternal = /** @class */ (function (_super) {
    __extends(CurrencyInternal, _super);
    function CurrencyInternal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurrencyInternal;
}(BaseCurrency));
exports.currencyInternal = new CurrencyInternal();
//# sourceMappingURL=BaseCurrency.js.map